export const formatPersonalNumber = (
  value: string,
  newValue: string
): string => {
  if (
    value.length > newValue.length &&
    value.length > 7 &&
    !value.includes('-')
  ) {
    return `${value.slice(0, 8)}-${value.slice(8)}`;
  }
  return value;
};
